import {
  SHOW_GLOBAL_LOADER,
} from '@/store/mutation-types';
import {globalLoader, fixBody} from '@/helpers/variables/index'


const state = {
  globalLoader: false,

};

const getters = {
  globalLoader: state => state.globalLoader,
};

const mutations = {

  [SHOW_GLOBAL_LOADER](state, status) {
    state.globalLoader = status
  },

};

export default {
  state,
  getters,
  mutations,
};
